<template>
    <div class="row g-4 mt-1" v-show="chartData.length">
        <template v-for="(item) in chartData" :key="item.index" >
            <div class="col-md-6" v-if="Object.keys(item.chartData).length">
                <div class="card usage-card h-100">
                    <div class="card-header">
                        <h2 class="card-header-title">{{ item.description }}</h2>
                    </div>
                    <div class="card-body">
                        <div class="chart-wrapper">
                            <canvas :ref="`chart${type + item.name}`" :id="`chart${type + item.name}`" class="chart-canvas">
                            </canvas>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>

</template>
<script>
import {
    Chart,
    ArcElement,
    LineElement,
    BarElement,
    PointElement,
    BarController,
    BubbleController,
    DoughnutController,
    LineController,
    PieController,
    PolarAreaController,
    RadarController,
    ScatterController,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    RadialLinearScale,
    TimeScale,
    TimeSeriesScale,
    Decimation,
    Filler,
    Legend,
    Title,
    Tooltip,
    SubTitle
} from 'chart.js';
import { styleDataset, barScales, tooltipStyle, limitLinePlugin } from '../../utils/chartTheme';


Chart.register(
    ArcElement,
    LineElement,
    BarElement,
    PointElement,
    BarController,
    BubbleController,
    DoughnutController,
    LineController,
    PieController,
    PolarAreaController,
    RadarController,
    ScatterController,
    CategoryScale,
    LinearScale,
    LogarithmicScale,
    RadialLinearScale,
    TimeScale,
    TimeSeriesScale,
    Decimation,
    Filler,
    Legend,
    Title,
    Tooltip,
    SubTitle
);

export default {
    props: {
        monthlyData: {
            type: Array,
            default: () => []
        },
        type: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            charts: [],
        }
    },
    watch: {
        monthlyData(value) {
            this.charts.map((mychart)=>{if(mychart) mychart.destroy();})
            this.$nextTick(() => {
                this.drawCharts()
            });
        }
    },
    mounted() {
        // Draw on mount so charts render when the component is (re)created with data
        // already present (e.g. returning to the Historical tab); the watcher won't fire then.
        this.$nextTick(() => this.drawCharts());
    },
    computed: {
        chartData () {

            //convert monthly data into chart edible data sets
            let baseEnts = {}
            Object.entries(this.monthlyData).forEach(([key, value], index) => {
                for (const ent of value) {
                    if (!baseEnts[ent.name]) {
                        baseEnts[ent.name] = ent
                        baseEnts[ent.name]['chartData'] = {};
                    }

                    if (ent.sub_entitlements) {
                        for (const subEnt of ent.sub_entitlements) {
                            if(!baseEnts[ent.name]['chartData'][subEnt.name]) {
                                baseEnts[ent.name]['chartData'][subEnt.name] = Array(Object.keys(this.monthlyData).length).fill({"key": key, "value": 0, "usage": 0})
                            }
                            baseEnts[ent.name]['chartData'][subEnt.name][index] = {"key":key, "value": subEnt.consumption, "usage": subEnt.usage}
                        }
                    }
                }
            });

            //convert to array
            var entitlements = []
            for (var key in baseEnts) {
                entitlements.push(baseEnts[key])
            }

            return entitlements
        }
    },
    methods: {
        drawCharts() {
            // Destroy any existing charts first so repeated draws (mount + watch) never
            // collide on a canvas that is "already in use".
            this.charts.forEach(c => { if (c && typeof c.destroy === 'function') c.destroy(); });
            this.charts = [];

            if (this.chartData.length) {
                for (const usageData of this.chartData) {
                    let datasets = []
                    if (usageData.chartData) {
                        for (const [subkey, subvalue] of Object.entries(usageData.chartData)) {
                            datasets.push(styleDataset({
                                label: subkey,
                                data: subvalue,
                                parsing: {
                                    xAxisKey: 'key',
                                    yAxisKey: 'value'
                                },
                            }, datasets.length))
                        }
                    }
                    //Entitlement POOLED CHART
                    const pooledChart = this.$refs['chart' + this.type + usageData.name]
                    const pooledLabels = Object.keys(this.monthlyData)
                    const pooledData = {
                        labels: pooledLabels,
                        datasets: datasets
                    };
                    const pooledConfig = {
                        type: 'bar',
                        data: pooledData,
                        options: {
                            plugins: {
                                title: {
                                    display: false,
                                    text: 'Usage'
                                },
                                legend: {
                                    display: true,
                                    position: 'bottom',
                                    labels: {
                                        usePointStyle: true,
                                        pointStyle: 'circle',
                                        boxWidth: 8,
                                        boxHeight: 8,
                                        padding: 16,
                                        color: '#6E84A3',
                                        font: { size: 11 },
                                    }
                                },
                                tooltip: tooltipStyle({
                                    afterLabel: function(context) {
                                        const usage = context.raw && context.raw.usage != null ? context.raw.usage : 0;
                                        return "Count: " + usage.toLocaleString();
                                    }
                                }),
                                limitLine: {
                                    label: 'Limit',
                                    limit: usageData.quantity,
                                }
                            },
                            responsive: true,
                            maintainAspectRatio: false,
                            layout: { padding: { top: 8 } },
                            scales: barScales()
                        },
                        plugins: [limitLinePlugin]
                    };
                    
                    if (pooledChart) {
                        this.charts.push(new Chart(pooledChart, pooledConfig));
                    }
                }

            }
        },

    },
    beforeUnmount(){
        this.charts.forEach(chart => {
            if (chart && typeof chart.destroy === 'function') {
                chart.destroy();
            }
        });
    }
}
</script>
<style scoped>
.chart-wrapper {
    position: relative;
    width: 100%;
    height: 320px;
}

.usage-card {
    border: 1px solid rgba(18, 38, 63, 0.06);
}
</style>